import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col, Button, Tabs, Tab } from "react-bootstrap";
import PriceUpdate from "./PriceUpdate";
import Customer from "./Customer";
import {Footer} from '../../../components/Footer'

const FileImports = ({ dispatch }) => {
  
  return (
    <section className="content dashboard">
      <div className="page-title">
        <h2 className="h2">File Imports</h2>
      </div>
      <div className="card">
        {/* <div className="card-body"> */}
            <PriceUpdate />
        {/* </div> */}
    </div>
      {/* <Tabs defaultActiveKey="drugPrice" id="uncontrolled-tab-example">
        <Tab eventKey="drugPrice" title="Drug Price">
          <Row>
            <Col md={12}>
                <div className="card">
                    <div className="card-body">
                        <PriceUpdate />
                    </div>
                </div>
            </Col>
          </Row>
        </Tab>
        <Tab
          eventKey="Customer"
          title="Customer" hidden="true"
        >
          <Row>
            <Col md={12}>
                <div className="card">
                    <div className="card-body">
                        <Customer />
                    </div>
                </div>
            </Col>
          </Row>
        </Tab>
      </Tabs> */}
        <Footer />
    </section>
  );
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
  loading: state.users.loading,
  login: state.users.login,
  users: state.users.users,
  hasErrors: state.users.hasErrors,
  tasks: state.tasks.tasks
});

// Connect Redux to React
export default connect(mapStateToProps)(FileImports);
